import type { ApiResponse } from '../models/ApiResponse';
import type { UserProfile } from '../models/AuthModels';
import type User from '../models/User';
import type { CurrentUserReponse } from '../models/User';
import type { UserPreferences } from '../models/UserPreferences';
import BaseService from './BaseService';

class CurrentUserService extends BaseService {
  public static getPreferences(): Promise<ApiResponse<UserPreferences>> {
    return this.get('/v1/my/preferences');
  }
  public static savePreferences(data: UserPreferences): Promise<ApiResponse<boolean>> {
    return this.put('/v1/my/preferences', { preferences: data });
  }

  public static updateProfile(body: UserProfile): Promise<ApiResponse<User>> {
    return this.put('/v1/my/profile', body);
  }

  public static getProfile(): Promise<ApiResponse<CurrentUserReponse>> {
    return this.get('/v1/my/profile');
  }
}

export default CurrentUserService;
